<div class="d-flex flex-row align-items-center">
  <ng-container *ngFor="let section of sections | async; index as i;">
    <ng-container *ngIf="section.isCompleted">
      <mat-icon
        class="step1 icon-circle-filled pointer"
        (click)="onClickSection(section.currentSection)">
        check_circle
      </mat-icon>
    </ng-container>
    <ng-container *ngIf="!section.isCompleted">
      <div
           class="outer-circle"
           [ngClass]="{'active': section.isActive}">
        <div
          class="inner-circle"
          [ngClass]="{'active': section.isActive}">
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
